import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { useWallets } from "@/api/wallets"
import ReceiveFlow from "./receive.flow"

interface ReceiveModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function ReceiveModal({ open, onOpenChange }: ReceiveModalProps) {
  const { wallet } = useWallets()

  if (!wallet) {
    return null
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Receive</DialogTitle>
          <DialogClose />
        </DialogHeader>
        <ReceiveFlow onDone={() => onOpenChange(false)} />
      </DialogContent>
    </Dialog>
  )
}
